import 'canceledInvoiceService'
import modalBlankCancelCtrl from './modalBlankCancelCtrl'
import modalSureCtrl from './modalSureCtrl'
import cancelInvoiceModule from './cancelInvoiceModule'

import { cancelInvoice,ovatBill,vehicleInvoice,openedInvoice,invoice,rollTypeInvoice } from 'redevConfig'

const list = (cancelInvoice && cancelInvoice.list) || ''
const detail = (cancelInvoice && cancelInvoice.detail) || ''
const relatedBill = (cancelInvoice && cancelInvoice.relatedBill) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''
const vehiceDetail = (vehicleInvoice && vehicleInvoice.add) || ''
const cancelInvoiceRollDetail = (cancelInvoice && cancelInvoice.rollDetail) || ''
const openedInvoiceRollDetail = (openedInvoice && openedInvoice.rollDetail) || ''
const invoiceEdit = (invoice && invoice.add) || ''
const addRoll = (rollTypeInvoice && rollTypeInvoice.add) || ''

const cancelInvoiceList = list ? require(`redevelopment/outputManage/cancelInvoice/${list.templateName}`) : require('./view/cancelInvoiceList.html')
const cancelInvoiceListCtrl = list ? require(`redevelopment/outputManage/cancelInvoice/${list.controllerName}`) : require('./cancelInvoiceListCtrl')
const cancelInvoiceDetail = detail ? require(`redevelopment/outputManage/cancelInvoice/${detail.templateName}`) : require('./view/cancelInvoiceDetail.html')
const cancelInvoiceDetailCtrl = detail ? require(`redevelopment/outputManage/cancelInvoice/${detail.controllerName}`) : require('./cancelInvoiceDetailCtrl')
const relatedBillInvoice = relatedBill ? require(`redevelopment/outputManage/cancelInvoice/${relatedBill.templateName}`) : require('./view/relatedBill_invoice.html')
const cancelRelatedBillCtrl = relatedBill ? require(`redevelopment/outputManage/cancelInvoice/${relatedBill.controllerName}`) : require('./cancelRelatedBillCtrl')
const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('../../fillOpenManage/ovatBill/view/checkBillDetailCtrl.html')
const vehicleDetailPage = vehiceDetail ? require(`redevelopment/outputManage/vehicleInvoice/${vehiceDetail.templateName}`) : require('app/outputManage/fillOpenManage/vehicleInvoice/view/add.html')
const addVehicleCtrl = vehiceDetail ? require(`redevelopment/outputManage/vehicleInvoice/${vehiceDetail.controllerName}`) : require('../../fillOpenManage/vehicleInvoice/add')
const rollDetailCtrl = cancelInvoiceRollDetail ? require(`redevelopment/outputManage/cancelInvoice/${cancelInvoiceRollDetail.controllerName}`) : require('./rollDetailCtrl')
const rollDetail = openedInvoiceRollDetail ? require(`redevelopment/outputManage/openedInvoice/${openedInvoiceRollDetail.templateName}`) : require('../openedInvoice/view/rollTypeInvoice.html')
const invoiceEditCtrl = invoiceEdit ? require(`redevelopment/outputManage/invoice/${invoiceEdit.controllerName}`) : require('../../fillOpenManage/invoice1/InvoiceEditCtrl')
const invoiceEditPage = invoiceEdit ? require(`redevelopment/outputManage/invoice/${invoiceEdit.templateName}`) : require('../../fillOpenManage/invoice1/view/invoiceEdit.html')
const addRollCtrl = addRoll ? require(`redevelopment/outputManage/rollTypeInvoice/${addRoll.controllerName}`) : require('../../fillOpenManage/rollTypeInvoice/add')
const addRollPage = addRoll ? require(`redevelopment/outputManage/rollTypeInvoice/${addRoll.templateName}`) : require('../../fillOpenManage/rollTypeInvoice/view/add.html')

function config($stateProvider) {
    // 'ngInject';
    $stateProvider
        .state('outputManage.billManage.cancelInvoice', {
            abstract: true,
            url: '/cancelInvoice',
            template: '<div ui-view></div>',
            title: '已作废发票',
            default: 'outputManage.billManage.cancelInvoice.list',
        })
        .state('outputManage.billManage.cancelInvoice.list', {
            url: '/list',
            template: cancelInvoiceList,
            controller: 'cancelInvoiceListCtrl',
        })
        .state('outputManage.billManage.cancelInvoice.detail', {
            url: '/detail/:invoiceId',
            title: '发票详情',
            template: cancelInvoiceDetail,
            controller: 'cancelInvoiceDetailCtrl',
        })
        .state('outputManage.billManage.cancelInvoice.relatedBill', {
            url: '/relatedBill/:waitId',
            template: relatedBillInvoice,
            controller: 'cancelRelatedBillCtrl',
            title: '关联销售单',
        })
        .state('outputManage.billManage.cancelInvoice.checkBillDetail', {
            url: '/checkBillDetail/:billId',
            template: checkBillDetailCtrl,
            controller: 'checkBillDetailCtrl',
            title: '销售单明细',
        })
        .state('outputManage.billManage.cancelInvoice.vehiceDetail', {
            url: '/vehiceDetail/:invoiceId',
            title: '发票详情',
            template: vehicleDetailPage,
            controller: 'vehicleDetailCtrl',
        })
        .state('outputManage.billManage.cancelInvoice.rollDetail', {
            url: '/rollDetail/:invoiceId',
            title: '发票详情',
            template: rollDetail,
            controller: 'rollDetailCtrl',
        })
        .state('outputManage.billManage.cancelInvoice.cancelNomal', {
            url: '/cancelNomal/:invType/:canceledInvoiceId',
            title: '专普票作废重开',
            template: invoiceEditPage,
            controller: 'invoiceEditCtrl',
        })
        .state('outputManage.billManage.cancelInvoice.cancelRoll', {
            url: '/cancelRoll/:invType/:canceledInvoiceId',
            title: '卷票作废重开',
            template: addRollPage,
            controller: 'addRollCtrl',
        })
        .state('outputManage.billManage.cancelInvoice.cancelVehicle', {
            url: '/cancelVehicle/:invType/:canceledInvoiceId',
            title: '机动车票作废重开',
            template: vehicleDetailPage,
            controller: 'addVehicleCtrl',
        })
}
export default cancelInvoiceModule
    .config(['$stateProvider', config])
    .controller('cancelInvoiceListCtrl', cancelInvoiceListCtrl.default)
    .controller('cancelInvoiceDetailCtrl', cancelInvoiceDetailCtrl.default)
    .controller('modalBlankCancelCtrl', modalBlankCancelCtrl)
    .controller('modalSureCtrl', modalSureCtrl)
    .controller('cancelRelatedBillCtrl', cancelRelatedBillCtrl.default)
    .controller('rollDetailCtrl', rollDetailCtrl.default)
    .controller('invoiceEditCtrl', invoiceEditCtrl.default)
    .controller('addRollCtrl', addRollCtrl.default)
    .controller('addVehicleCtrl', addVehicleCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/index.js